export const openSMSApp = (cellPhone: string) => {
  const smsUrl = `sms:${cellPhone}`;
  window.location.href = smsUrl;
};

export function normalizePhoneNumber(input?: string): string | null {
  if (!input) return null;

  const digits = input.replace(/\D/g, '');
  if (digits.length < 8 || digits.length > 15) return null;

  return digits;
}
